module.exports = __webpack_public_path__ + "static/slide5-e484c63931f5e2fb879c38b52b30a9e5.jpg";